// extracted by mini-css-extract-plugin
module.exports = {"alert-history-modal":"AlertHistoryModal_alert-history-modal__FNj_Y","alert-history-nowrap":"AlertHistoryModal_alert-history-nowrap__3znJm"};